import { render } from "./MenuCalcots.vue?vue&type=template&id=2ca1f35b&scoped=true"
import script from "./MenuCalcots.vue?vue&type=script&lang=js"
export * from "./MenuCalcots.vue?vue&type=script&lang=js"

import "./MenuCalcots.vue?vue&type=style&index=0&id=2ca1f35b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca1f35b"]])

export default __exports__